import { FirestoreDataConverter } from "firebase/firestore";
import { omitBy } from "lodash";
import moment from "moment";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";
import VersaoTermo from "../models/versaoTermo";

export default class VersaoTermoDb extends BaseDb<
  VersaoTermo,
  { termoId: string; versaoId: string }
> {
  _path = "termos/termoId/versoes/versaoId";

  getConverter(): FirestoreDataConverter<VersaoTermo> {
    return {
      fromFirestore: (snapshot) =>
        new VersaoTermo({
          ref: snapshot.ref.withConverter(this.getConverter()),
          numero: snapshot.get("numero"),
          conteudo: snapshot.get("conteudo"),
          hash: snapshot.get("hash"),
          situacao: snapshot.get("situacao"),
          criadoEm: snapshot.get("criadoEm") ? moment(snapshot.get("criadoEm").toDate()) : undefined,
          publicadoEm: snapshot.get("publicadoEm") ? moment(snapshot.get("publicadoEm").toDate()) : undefined,
        }),
      toFirestore: (versao) => toFirestore(omitBy(versao, ["ref"])),
    };
  }
}